module.exports = __webpack_public_path__ + "static/about-title-bg-stats-b32fe709a2216c1edff5588317f5cbe4.png";